import React, { useEffect, useRef } from 'react'
import useNewItemChange from '../../EHR Settings/Templates/OpenTemplate/FormBuilder/hooks/useNewItemChange';
import ValidationText from '../../EHR Settings/Templates/OpenTemplate/FormBuilder/Items/ValidationText';
const SimpleQuestion = ({ item, setItem, validations, activeAccordion }) => {
  // let activeAccordion = 'Intake Form';
  console.log("validationItemsModal SimpleQuestion", validations);
  const { handleSetAnswer } = useNewItemChange(setItem, 'Viewer', activeAccordion);
  const textareaRef = useRef(null);

  const autoResize = () => {
    const el = textareaRef.current;
    if (!el) return;

    el.style.setProperty("height", "100px", "important");
    el.style.setProperty(
      "height",
      `${Math.max(100, el.scrollHeight)}px`,
      "important"
    );
  };
  useEffect(() => {
    autoResize();
  }, [item.answer]);

  return (
    <div className='content-box d-flex gap-10'>
      <p className={`text text-black w-231px flex-shrink-0 d-flex  justify-content-end gap-01 text-end ${validations?.isInvalid ? 'Denied-clr' : ''}`}>
        {item.content || '[Enter prompt or question]'}
        {[true, "true"].includes(item?.isRequired) ? <span className="text font-m Denied-clr fs-14">*</span> : <></>}
      </p>
      {item.MultiLineAnswer === "true" ?
        <div className={`input w-100  ${validations.isInvalid ? 'error' : ''}`}>
          <textarea
            ref={textareaRef}
            className="form-control overflow-hidden"
            rows={3}
            value={item.answer}
            onChange={(e) => handleSetAnswer(e, item)}
          />
          <ValidationText name={item.name} />
        </div>
        :

        <div className={`input mb-0 w-100  ${validations.isInvalid ? 'error' : ''}`}>
          <input
            type="text"
            className="form-control"
            value={item.answer}
            onChange={(e) => handleSetAnswer(e, item)}
          />
          <ValidationText name={item.name} />
        </div>
      }
    </div>
  )
}

export default SimpleQuestion